module.exports = __webpack_public_path__ + "static/media/2.82359aa0.png";